// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__epCxW","info":"UpdateTermsInfo_info__3bweA"};